import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./watchDemo.html";
import { ElementTitle, ElementType } from '~/modules/analytics/gtmEventTypes/constants';
import { createUserActivity } from '~/modules/services/simplifiedTrialsService';
import { images } from '~/modules/utilities/assetUtilities';
const DEMO_ACTIVITY_TYPE = 'Demo';
const YOUTUBE_VIDEO_ID_PATTERN = /^[\w-]{11}$/;
const getYouTubeVideoId = url => {
  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname.replace(/^www\./, '');
    if (hostname === 'youtu.be') {
      return parsedUrl.pathname.split('/')[1] ?? null;
    }
    if (hostname === 'youtube.com' || hostname === 'm.youtube.com') {
      if (parsedUrl.pathname === '/watch') {
        return parsedUrl.searchParams.get('v');
      }
      return parsedUrl.pathname.match(/^\/(?:embed|shorts)\/([^/]+)/)?.[1] ?? null;
    }
  } catch {
    return null;
  }
  return null;
};
class WatchDemo extends LightningElement {
  constructor(...args) {
    super(...args);
    this.heading = '';
    this.href = '';
    /**
     * The partner's Demo URL, used only to derive the media preview. Lead-enabled
     * demos navigate to the legacy lead page instead, so `href` carries no video
     * id in that case. Falls back to `href` when not supplied.
     */
    this.previewUrl = '';
    this.label = '';
    /** When true, the legacy lead page records the lead — skip createUserActivity. */
    this.hasDemoLeadsEnabled = false;
  }
  get youtubeVideoId() {
    const videoId = getYouTubeVideoId(this.previewUrl || this.href);
    return videoId && YOUTUBE_VIDEO_ID_PATTERN.test(videoId) ? videoId : null;
  }

  /**
   * `hqdefault` is 480x360: a 16:9 frame plus black letterbox bars. Cropping the bars
   * leaves a 480x270 frame — sharper than `mqdefault`'s 320x180, which matters once the
   * stacked layout scales the preview to the full banner width. The crop is done by
   * oversizing this image inside an `overflow: hidden` wrapper rather than by holding
   * the box at 16:9, which is what frees the strip to take the banner's height; see
   * `.watch-demo__preview` in watchDemo.css.
   */
  get mediaSrc() {
    return this.youtubeVideoId ? `https://i.ytimg.com/vi/${this.youtubeVideoId}/hqdefault.jpg` : images.watchDemoMedia;
  }
  get watchDemoClass() {
    return this.youtubeVideoId ? 'watch-demo watch-demo--video' : 'watch-demo';
  }
  get isPlaceholder() {
    return !this.href;
  }
  get watchDemoAnalyticsContext() {
    return {
      // GA4 derives the demo click's element_title from lead_type === 'demo'
      // (GtmListingDetailClickType.getItemTitle). V1's carousel demo tile set
      // this, so keep it here to hold element_title at 'watch demo'.
      lead_type: 'demo',
      elementType: ElementType.BANNER,
      clickUrl: this.href,
      button: {
        callToAction: {
          name: ElementTitle.WATCH_DEMO,
          url: this.href
        }
      }
    };
  }
  handleClick() {
    if (!this.href) {
      return;
    }
    // Match listing-carousel demo tile: lead-enabled demos open the legacy
    // lead page, which records the lead itself.
    if (!this.hasDemoLeadsEnabled) {
      createUserActivity(DEMO_ACTIVITY_TYPE);
    }
    window.open(this.href, '_blank', 'noopener,noreferrer');
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(WatchDemo, {
  publicProps: {
    heading: {
      config: 0
    },
    href: {
      config: 0
    },
    previewUrl: {
      config: 0
    },
    label: {
      config: 0
    },
    hasDemoLeadsEnabled: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(WatchDemo, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;